export const DISCLAIMER =
  "Bids are not reversible. Make sure you've completed your research before bidding."
export const ZERO_DOLLARS = '$0'
